
// * KEY
export const AUTH_USER = "AUTH_USER";
export const FIND_USER = "FIND_USER";